<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      errorMessageCoordinator: errorMessageCoordinator$ | async,
      errorMessageParticipant: errorMessageParticipant$ | async,
      readOnly: readOnly$ | async,
    };
    as data
  ) {
    <div
      class="form-group question-container-inner worksite"
      [formGroup]="questionForm"
    >
      <div class="row">
        <div class="col">
          <div>
            <lib-input-container
              [labelPrefix]="questionNumber$ | async"
              [label]="t('worksite_coordinating_participant')"
              [labelHeader]="true"
              [headLine]="
                question.translations?.list['headLine']
                  | translate: data.activeLang : question.structure.headLine
              "
              [questionMarkText]="
                isSharedView
                  ? undefined
                  : t('worksite_coordinator_questionmark')
              "
              [required]="question.validation.required"
              [requiredTextEnd]="false"
              [errorText]="data.errorMessageCoordinator"
              [description]="
                question.translations?.list['description']
                  | translate: data.activeLang : question.structure.description
              "
              [hideBelow]="isSharedView"
            >
              <div class="coordinator">
                <lib-list
                  [addMoreVisible]="
                    (allowedToAddCoordinatingParticipant$ | async) &&
                    !data.readOnly
                  "
                  [addMoreText]="t('worksite_btn_add_coordinator')"
                  (addMore)="onOpenOregModal(oregModal, true)"
                >
                  @if (coordinatorWorksite) {
                    <lib-list-item
                      [editVisible]="true"
                      [removeVisible]="false"
                      (edit)="onOpenRemoveWorksiteModal(removeCoordinatorModal)"
                      [readOnlyState]="
                        data.readOnly || isChangeRequest() || isSharedView
                      "
                      [isMobile]="isMobile()"
                      [title]="coordinatorWorksite.company?.name"
                    >
                      <div view-title>
                        <div class="heading-size-5 mt-0">
                          <div class="title-single-line">
                            <lib-dot-indicator
                              [label]="t('worksite_new')"
                              [ariaLabel]="t('worksite_has_changes')"
                              [isVisible]="
                                showChanges() && coordinatorWorksite.isNew
                              "
                            />
                            {{ coordinatorWorksite.company?.name }}
                          </div>
                        </div>
                        <div class="org-number">
                          @if (isForeign(coordinatorWorksite.id)) {
                            @if (coordinatorWorksite.company?.vat) {
                              <p class="mb-0">
                                {{ t('worksite_other_unique_number') }}:
                              </p>
                              <p>
                                {{
                                  coordinatorWorksite.company
                                    ?.nationalRegistrationNumber
                                }}
                              </p>
                            } @else if (
                              coordinatorWorksite.company
                                ?.nationalRegistrationNumber
                            ) {
                              <p class="mb-0">
                                {{ t('worksite_other_unique_number') }}:
                              </p>
                              <p>
                                {{
                                  coordinatorWorksite.company
                                    ?.nationalRegistrationNumber
                                }}
                              </p>
                            }
                          } @else if (coordinatorWorksite.company) {
                            <p class="mb-0">
                              {{ t('worksite_registration_number') }}:
                            </p>
                            <p>
                              {{
                                coordinatorWorksite.company
                                  ?.nationalRegistrationNumber
                              }}
                            </p>
                          }
                        </div>
                      </div>

                      <div view>
                        <p class="mb-0">{{ coordinatorWorksite?.name }}</p>
                        <p class="mb-0">
                          {{ coordinatorWorksite?.department }}
                        </p>
                        <p class="mb-0">
                          {{ coordinatorWorksite?.address }},
                          {{ coordinatorWorksite?.zipcode | zipCode }}
                          {{ coordinatorWorksite?.city }},
                          {{
                            coordinatorWorksite?.country
                              | translatedCountry: data.activeLang
                          }}
                        </p>
                        <p class="mb-0">
                          {{ coordinatorWorksite?.phone | formatPhonenumber }}
                        </p>
                      </div>
                    </lib-list-item>
                    <div class="financier-container">
                      @if (!hideFinanciers) {
                        <lib-financier
                          [questionForm]="questionForm"
                          (addFinancierEmitter)="
                            onFinancierAdded($event, coordinatorWorksite.id)
                          "
                          (removeFinancierEmitter)="
                            onFinancierRemoved($event, coordinatorWorksite.id)
                          "
                          [parentWorksite]="coordinatorWorksite.id"
                          [readOnlyState]="data.readOnly"
                          [isMobile]="isMobile()"
                        ></lib-financier>
                      }
                    </div>
                    @if (
                      (allowedToAddCoordinatingParticipant$ | async) &&
                      data.readOnly
                    ) {
                      <div class="readonly invalid"></div>
                    }
                  }
                </lib-list>
              </div>
            </lib-input-container>
          </div>
        </div>
        @if (!hideParticipants) {
          <div class="participant-list">
            <lib-input-container
              [label]="t('worksite_participants')"
              [labelHeader]="true"
              [questionMarkText]="
                isSharedView
                  ? undefined
                  : t('worksite_participants_questionmark')
              "
              [required]="question.validation.minLength"
              [markRequired]="isChangeRequest()"
              [requiredTextEnd]="false"
              [errorText]="data.errorMessageParticipant"
              [helpText]="helpTextParticipant$ | async"
              [hideBelow]="isSharedView"
            >
              <lib-list
                [addMoreVisible]="allowedToAddMore && !data.readOnly"
                [addMoreText]="t('worksite_btn_add')"
                [class.projektpart-invalid]="data.errorMessageParticipant"
                (addMore)="onOpenOregModal(oregModal)"
              >
                @for (worksite of participantsWorksites; track worksite.id) {
                  <div class="participant" [class.shared-view]="isSharedView">
                    <lib-list-item
                      [editVisible]="false"
                      [removeVisible]="true"
                      [showHorizontalLine]="true"
                      [isMobile]="isMobile()"
                      (remove)="
                        onOpenRemoveWorksiteModal(removeModal, worksite)
                      "
                      [readOnlyState]="data.readOnly"
                      [title]="worksite.company?.name"
                      (toggle)="toggle(worksite, toggleModal)"
                      [showToggler]="
                        (useToggle && !worksite.isNew) ||
                        (worksite.isPreviousKoordinerande && this.isSharedView)
                      "
                      [(togglerValue)]="
                        worksiteInactiveToggleValue[worksite.id]
                      "
                      [togglerTextInactive]="t('worksite_toggle_inactive')"
                      [togglerTextActive]="t('worksite_toggle_active')"
                    >
                      <div view-title>
                        <div class="heading-size-5 mt-0">
                          <div class="title-single-line">
                            <lib-dot-indicator
                              [label]="
                                worksite.isInactiveChanged
                                  ? t('worksite_inactive')
                                  : t('worksite_new')
                              "
                              [ariaLabel]="t('worksite_has_changes')"
                              [isVisible]="
                                showChanges() &&
                                ((worksite.isInactive &&
                                  worksite.isInactiveChanged) ||
                                  worksite.isNew)
                              "
                            />
                            @if (worksite.isInactive) {
                              <s class="inactive-text">
                                {{ worksite.company?.name }}
                              </s>
                            } @else {
                              {{ worksite.company?.name }}
                            }
                          </div>
                        </div>
                        <div class="org-number">
                          @if (isForeign(worksite.id)) {
                            @if (worksite.company?.vat) {
                              <p
                                [ngClass]="
                                  worksite.isInactive ? 'inactive-text' : ''
                                "
                                class="mb-0"
                              >
                                {{ t('worksite_registration_number') }}:
                              </p>
                              <p
                                [ngClass]="
                                  worksite.isInactive ? 'inactive-text' : ''
                                "
                              >
                                {{
                                  worksite.company?.nationalRegistrationNumber
                                }}
                              </p>
                            }
                          } @else if (
                            worksite.company?.nationalRegistrationNumber
                          ) {
                            <p
                              [ngClass]="
                                worksite.isInactive ? 'inactive-text' : ''
                              "
                              class="mb-0"
                            >
                              {{ t('worksite_registration_number') }}:
                            </p>
                            <p
                              [ngClass]="
                                worksite.isInactive ? 'inactive-text' : ''
                              "
                            >
                              {{ worksite.company?.nationalRegistrationNumber }}
                            </p>
                          }
                        </div>
                      </div>

                      <div
                        view
                        [ngClass]="worksite.isInactive ? 'inactive-text' : ''"
                      >
                        <p class="mb-3">{{ worksite?.name }}</p>
                        <p class="mb-3">
                          {{ worksite?.department }}
                        </p>
                        <p class="mb-1">
                          {{ worksite?.address }}
                        </p>
                        <p class="mb-1">
                          {{ worksite?.zipcode | zipCode }}
                          {{ worksite?.city }}
                        </p>
                        <p class="mb-1">
                          {{
                            worksite?.country
                              | translatedCountry: data.activeLang
                          }}
                        </p>
                        <p class="mb-0 mt-3">
                          {{ worksite?.phone | formatPhonenumber }}
                        </p>
                      </div>
                    </lib-list-item>
                    <div class="financier-container">
                      @if (!hideFinanciers) {
                        <lib-financier
                          [questionForm]="questionForm"
                          (addFinancierEmitter)="
                            onFinancierAdded($event, worksite.id)
                          "
                          (removeFinancierEmitter)="
                            onFinancierRemoved($event, worksite.id)
                          "
                          [parentWorksite]="worksite.id"
                          [readOnlyState]="data.readOnly"
                          [worksiteInactive]="worksite.isInactive"
                          [isMobile]="isMobile()"
                        ></lib-financier>
                      }
                    </div>
                  </div>
                }
              </lib-list>
              @if (projektpartsRequired && data.readOnly) {
                <div class="readonly invalid"></div>
              }
            </lib-input-container>
          </div>
        }
      </div>
    </div>
    <ng-template #oregModal>
      <lib-modal [showCloseButton]="true" (closeModal)="onCloseOregModal()">
        <lib-oreg
          [alreadySelectedWorksites]="worksiteProviderIds"
          [alreadySelectedFinanciers]="alreadySelectedFinanciers"
          [isFinancierSearch]="isFinancierSearch"
          (selectedWorksiteEvent)="
            onSelectedWorksite(personnummerVarningModal, $event)
          "
        ></lib-oreg>
      </lib-modal>
    </ng-template>
    <ng-template #removeCoordinatorModal>
      <lib-modal
        (closeModal)="onCloseRemoveModal()"
        [showCloseButton]="true"
        [title]="t('worksite_change_worksite_modal_title')"
        [primaryButtonText]="t('worksite_btn_change')"
        [showPrimaryButton]="true"
        [secondaryButtonText]="t('worksite_btn_keep')"
        [showSecondaryButton]="true"
        (primaryButton)="onCloseRemoveModal(); onOpenOregModal(oregModal, true)"
        (secondaryButton)="onCloseRemoveModal()"
        ><div>{{ t('worksite_change_worksite_modal_description') }}</div>
      </lib-modal>
    </ng-template>
    <ng-template #removeModal>
      <lib-modal
        (closeModal)="onCloseRemoveModal()"
        [showCloseButton]="true"
        [title]="t('worksite_remove_worksite_modal_title')"
        [primaryButtonText]="t('worksite_btn_remove')"
        [showPrimaryButton]="true"
        [secondaryButtonText]="t('worksite_btn_keep')"
        [showSecondaryButton]="true"
        (primaryButton)="onRemoveWorksite()"
        (secondaryButton)="onCloseRemoveModal()"
        ><div>{{ t('worksite_remove_worksite_modal_description') }}</div>
      </lib-modal>
    </ng-template>
    <ng-template #toggleModal>
      <lib-modal
        (closeModal)="onCloseToggleModal()"
        [showCloseButton]="true"
        [title]="t('worksite_inactivate_modal_title')"
        [primaryButtonText]="t('worksite_inactivate_modal_primary_button')"
        [showPrimaryButton]="true"
        (primaryButton)="onCloseToggleModal()"
        ><div>
          <p>
            {{ t('worksite_inactivate_modal_text_1') }}
          </p>
          <ul class="mt-3">
            <li>
              {{ t('worksite_inactivate_modal_text_2') }}
            </li>
            <li>
              {{ t('worksite_inactivate_modal_text_3') }}
            </li>
            <li>
              {{ t('worksite_inactivate_modal_text_4') }}
            </li>
          </ul>
        </div>
      </lib-modal>
    </ng-template>
    <ng-template #personnummerVarningModal>
      <lib-modal
        (closeModal)="onClosePersonnummerVarningModal()"
        [showCloseButton]="true"
        [title]="t('worksite_personnummer_varning_modal_title')"
        [primaryButtonText]="t('worksite_personnummer_varning_modal_close')"
        [showPrimaryButton]="true"
        (primaryButton)="onClosePersonnummerVarningModal()"
        ><div>{{ t('worksite_personnummer_varning_modal_description') }}</div>
      </lib-modal>
    </ng-template>
  }
</ng-container>
